import mensagemVisibilidadeClienteAplicar from "../../../../helpers/mensagemVisibilidadeClienteAplicar"
import { canais } from "../../../../utils/canais"

/**
 * Aplica máscara de visibilidade a mensagens recebidas via socket (create/update).
 * @param {object} oMensagem
 * @param {object} oUsuario
 * @param {number} [nCanalTipoId]
 * @param {number|null} [nTicketResponsavelId]
 */
export default function mensagemSocketVisibilidadeAplicar(
  oMensagem,
  oUsuario,
  nCanalTipoId,
  nTicketResponsavelId = null
) {
  return mensagemVisibilidadeClienteAplicar(oMensagem, oUsuario, {
    lCanalInterno: nCanalTipoId === canais.interno,
    nTicketResponsavelId,
  })
}
